import { useSelector } from "react-redux";

const DEFAULT_CURRENCY = "TND";
const CURRENCY_MAP = {
  TND: {
    code: "TND",
    symbol: "TND",
    name: "Tunisian Dinar",
    decimalPlaces: 3,
  },
  EUR: {
    code: "EUR",
    symbol: "€",
    name: "Euro",
    decimalPlaces: 2,
  },
  USD: {
    code: "USD",
    symbol: "$",
    name: "US Dollar",
    decimalPlaces: 2,
  },
};

/**
 * Returns the currency selected for the active company.
 *
 * Currency is stored in:
 * state.company.company.companyCurrency
 *
 * Example:
 * "TND"
 * "EUR"
 * "USD"
 */
export const useCurrency = () => {
  const company = useSelector((state) => state.company?.company);

  const rawCurrency = company?.companyCurrency || DEFAULT_CURRENCY;

  // Normalize values coming from the backend.
  // Your current GeneralSettings uses:
  // TND, €, $
  const currencyCode =
    rawCurrency === "€"
      ? "EUR"
      : rawCurrency === "$"
        ? "USD"
        : rawCurrency?.toUpperCase?.() || DEFAULT_CURRENCY;

  const currency = CURRENCY_MAP[currencyCode] || CURRENCY_MAP[DEFAULT_CURRENCY];

  return currency;
};

export default useCurrency;